var map = {
	"./abw.svg": "E0I8",
	"./afg.svg": "L7y+",
	"./ago.svg": "ZBtw",
	"./aia.svg": "chg/",
	"./ala.svg": "+dB7",
	"./alb.svg": "cQwT",
	"./and.svg": "Rbyi",
	"./are.svg": "l7H2",
	"./arg.svg": "8mL/",
	"./arm.svg": "9AEl",
	"./asm.svg": "wNvv",
	"./ata.svg": "RIJe",
	"./atf.svg": "1KgF",
	"./atg.svg": "VFzZ",
	"./aus.svg": "sebd",
	"./aut.svg": "i+5T",
	"./aze.svg": "vuCp",
	"./bdi.svg": "SlzI",
	"./bel.svg": "+AAO",
	"./ben.svg": "7eUX",
	"./bes.svg": "IJvQ",
	"./bfa.svg": "HO5U",
	"./bgd.svg": "fpYD",
	"./bgr.svg": "DKgA",
	"./bhr.svg": "Hnpc",
	"./bhs.svg": "vANf",
	"./bih.svg": "cEqs",
	"./blm.svg": "oXxo",
	"./blr.svg": "FYob",
	"./blz.svg": "iaTU",
	"./bmu.svg": "Ljk7",
	"./bol.svg": "Lqh+",
	"./bra.svg": "1lQZ",
	"./brb.svg": "jEgr",
	"./brn.svg": "YHML",
	"./btn.svg": "aDH4",
	"./bvt.svg": "xfi0",
	"./bwa.svg": "IoEN",
	"./caf.svg": "MvE2",
	"./can.svg": "XJqb",
	"./cck.svg": "4f1J",
	"./che.svg": "cDQn",
	"./chl.svg": "nWIG",
	"./chn.svg": "sHDI",
	"./civ.svg": "avB/",
	"./cmr.svg": "DivT",
	"./cod.svg": "LR5p",
	"./cog.svg": "w2Jc",
	"./cok.svg": "oLcW",
	"./col.svg": "gaj3",
	"./com.svg": "K9kL",
	"./cpv.svg": "MnSs",
	"./cri.svg": "g+3r",
	"./cub.svg": "2lpu",
	"./cuw.svg": "WsH6",
	"./cxr.svg": "IxPX",
	"./cym.svg": "XkSN",
	"./cyp.svg": "Lwov",
	"./cze.svg": "o0BQ",
	"./deu.svg": "dKhQ",
	"./dji.svg": "j3Vi",
	"./dma.svg": "pXrZ",
	"./dnk.svg": "vkAE",
	"./dom.svg": "L5Ck",
	"./dza.svg": "kykR",
	"./ecu.svg": "E/j8",
	"./egy.svg": "X4N8",
	"./eng.svg": "j4jj",
	"./eri.svg": "KmdX",
	"./esh.svg": "sThf",
	"./esp.svg": "j9ke",
	"./est.svg": "eE3/",
	"./eth.svg": "jDBc",
	"./eur.svg": "+XJZ",
	"./fin.svg": "R/GH",
	"./fji.svg": "+Mdv",
	"./flk.svg": "UvcP",
	"./fra.svg": "qpU9",
	"./fro.svg": "e/Tr",
	"./fsm.svg": "sibR",
	"./gab.svg": "BbhZ",
	"./gbr.svg": "yEke",
	"./geo.svg": "RuYk",
	"./ggy.svg": "Ynr0",
	"./gha.svg": "rnmm",
	"./gib.svg": "uRjA",
	"./gin.svg": "Vyxi",
	"./glp.svg": "JGWh",
	"./gmb.svg": "snZc",
	"./gnb.svg": "yGho",
	"./gnq.svg": "OMCF",
	"./grc.svg": "AlBz",
	"./grd.svg": "dO25",
	"./grl.svg": "FMQl",
	"./gtm.svg": "LBY8",
	"./guf.svg": "KBIZ",
	"./gum.svg": "tydU",
	"./guy.svg": "LcNC",
	"./hkg.svg": "28qj",
	"./hmd.svg": "CsD7",
	"./hnd.svg": "c8pD",
	"./hrv.svg": "cVrg",
	"./hti.svg": "5/7h",
	"./hun.svg": "C5OG",
	"./idn.svg": "GtPM",
	"./imn.svg": "HVBp",
	"./ind.svg": "+YZl",
	"./iot.svg": "NQhf",
	"./irl.svg": "lmDE",
	"./irn.svg": "5u2L",
	"./irq.svg": "0NGG",
	"./isl.svg": "kmh3",
	"./isr.svg": "Bt9o",
	"./ita.svg": "cm45",
	"./jam.svg": "Rq12",
	"./jey.svg": "AJTF",
	"./jor.svg": "tLtX",
	"./jpn.svg": "AuAw",
	"./kaz.svg": "llA4",
	"./ken.svg": "ZK6r",
	"./kgz.svg": "l4lT",
	"./khm.svg": "Gt+L",
	"./kir.svg": "DUg0",
	"./kna.svg": "2jRR",
	"./kor.svg": "od2Q",
	"./kos.svg": "6y9A",
	"./kwt.svg": "+w3q",
	"./lao.svg": "R958",
	"./lbn.svg": "EaRf",
	"./lbr.svg": "On0+",
	"./lby.svg": "7CDZ",
	"./lca.svg": "0Eji",
	"./lie.svg": "FnKY",
	"./lka.svg": "H97N",
	"./lso.svg": "w5qo",
	"./ltu.svg": "LwGC",
	"./lux.svg": "SRc4",
	"./lva.svg": "uuFZ",
	"./mac.svg": "QUoT",
	"./maf.svg": "O85v",
	"./mar.svg": "s9uv",
	"./mco.svg": "XF/U",
	"./mda.svg": "QCQC",
	"./mdg.svg": "+Hui",
	"./mdv.svg": "BeFy",
	"./mex.svg": "eaCE",
	"./mhl.svg": "hSbA",
	"./mkd.svg": "qa0Z",
	"./mli.svg": "eUl5",
	"./mlt.svg": "hojo",
	"./mmr.svg": "1j3V",
	"./mne.svg": "kZWu",
	"./mng.svg": "mbum",
	"./mnp.svg": "4juW",
	"./moz.svg": "/7Bd",
	"./mrt.svg": "4aw5",
	"./msr.svg": "x2QM",
	"./mtq.svg": "+laI",
	"./mus.svg": "W1bk",
	"./mwi.svg": "VwrH",
	"./mys.svg": "bzeZ",
	"./myt.svg": "dFZo",
	"./nam.svg": "w/4L",
	"./ncl.svg": "1sO3",
	"./ner.svg": "M3Mn",
	"./nfk.svg": "JCNy",
	"./nga.svg": "r5cy",
	"./nic.svg": "v/VT",
	"./nir.svg": "z5o1",
	"./niu.svg": "apj1",
	"./nld.svg": "+QGd",
	"./nor.svg": "2O6w",
	"./npl.svg": "fwVh",
	"./nru.svg": "ybNF",
	"./nzl.svg": "d1iP",
	"./omn.svg": "rO8p",
	"./pak.svg": "dl2s",
	"./pan.svg": "CeZV",
	"./pcn.svg": "DpK4",
	"./per.svg": "Tayt",
	"./phl.svg": "LBb0",
	"./plw.svg": "ObPo",
	"./png.svg": "wLgq",
	"./pol.svg": "F7sJ",
	"./pri.svg": "DSjE",
	"./prk.svg": "HuMV",
	"./prt.svg": "UbD8",
	"./pry.svg": "uaHl",
	"./pse.svg": "Fg7E",
	"./pyf.svg": "PZIf",
	"./qat.svg": "eUyL",
	"./reu.svg": "9ey1",
	"./rou.svg": "c1R1",
	"./rus.svg": "tpqU",
	"./rwa.svg": "a9hd",
	"./sau.svg": "xNif",
	"./sco.svg": "AMSP",
	"./sdn.svg": "YqQg",
	"./sen.svg": "eg0X",
	"./sgp.svg": "jnG8",
	"./sgs.svg": "vq/M",
	"./shn.svg": "v0qB",
	"./sjm.svg": "VwFZ",
	"./slb.svg": "h6v2",
	"./sle.svg": "wCbi",
	"./slv.svg": "BfYO",
	"./smr.svg": "GgW9",
	"./som.svg": "S2u8",
	"./spm.svg": "t7ud",
	"./srb.svg": "UVtA",
	"./ssd.svg": "cPvi",
	"./stp.svg": "0Oj4",
	"./sur.svg": "zvxl",
	"./svk.svg": "Ab9r",
	"./svn.svg": "bVwC",
	"./swe.svg": "Azu0",
	"./swz.svg": "1ecN",
	"./sxm.svg": "uGRX",
	"./syc.svg": "airY",
	"./syr.svg": "qLZF",
	"./tca.svg": "qh5f",
	"./tcd.svg": "+EVO",
	"./tgo.svg": "kJBO",
	"./tha.svg": "L/V+",
	"./tjk.svg": "YzTi",
	"./tkl.svg": "m3MG",
	"./tkm.svg": "n4yd",
	"./tls.svg": "88qK",
	"./ton.svg": "wztd",
	"./tpe.svg": "N6KF",
	"./tto.svg": "E1Dm",
	"./tun.svg": "lA0U",
	"./tur.svg": "4kv+",
	"./tuv.svg": "Ak5F",
	"./twn.svg": "9czI",
	"./tza.svg": "DjYR",
	"./uga.svg": "sa68",
	"./ukr.svg": "k3Al",
	"./umi.svg": "v5Uo",
	"./ury.svg": "QNDc",
	"./usa.svg": "TXld",
	"./uzb.svg": "qYQz",
	"./vat.svg": "2tF/",
	"./vct.svg": "25um",
	"./ven.svg": "oKHV",
	"./vgb.svg": "vWL5",
	"./vir.svg": "L+4k",
	"./vnm.svg": "b7jG",
	"./vut.svg": "uDJx",
	"./wal.svg": "nJCH",
	"./wlf.svg": "/Z7g",
	"./wsm.svg": "6udx",
	"./yem.svg": "vXYd",
	"./zaf.svg": "86AH",
	"./zmb.svg": "ec8T",
	"./zwe.svg": "e246"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pUN7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags ^\.\/.*\.svg$
// module id = pUN7
// module chunks = 0